import React from 'react';

export const SearchIcon: React.FC<{ size?: number; className?: string }> = ({
  size = 20,
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.35-4.35" />
  </svg>
);

interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onSearch?: () => void;
  searchLabel?: string;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  onSearch,
  searchLabel = 'Buscar',
  className = '',
  ...props
}) => {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && onSearch) {
      onSearch();
    }
  };

  return (
    <div className={`search-input-wrapper ${className}`}>
      <span className="search-input-icon" aria-hidden="true">
        <SearchIcon size={18} />
      </span>
      <input
        {...props}
        className="form-control search-input"
        onKeyPress={handleKeyPress}
        aria-label={props.placeholder || searchLabel}
      />
      {onSearch && (
        <button
          type="button"
          onClick={onSearch}
          className="btn btn-primary search-input-btn"
          title={searchLabel}
        >
          {searchLabel}
        </button>
      )}
    </div>
  );
};
